export function readingTarget(rows: { id: string; top: number }[], line: number): string | null {
  let current: string | null = rows[0]?.id ?? null;
  for (const row of rows) {
    if (row.top > line) break;
    current = row.id;
  }
  return current;
}

export interface ViewRow {
  id: string;
  top: number;
  bottom: number;
}

export function rowsAround(rows: ViewRow[], line: number, count: number): string[] {
  let anchor = -1;
  rows.forEach((row, i) => {
    if (row.top <= line) anchor = i;
  });
  const row = rows[anchor];
  if (!row) return [];
  if (count === 1) return row.bottom > line ? [row.id] : [];
  const start = Math.max(0, Math.min(anchor - Math.floor((count - 1) / 2), rows.length - count));
  return rows.slice(start, start + count).map((r) => r.id);
}

export type RunPosition = 'single' | 'start' | 'middle' | 'end';

export function runPositions(changed: boolean[]): (RunPosition | null)[] {
  return changed.map((on, i) => {
    if (!on) return null;
    const joinsPrev = changed[i - 1] === true;
    const joinsNext = changed[i + 1] === true;
    if (joinsPrev) return joinsNext ? 'middle' : 'end';
    return joinsNext ? 'start' : 'single';
  });
}

export const changedRowClass = (run: RunPosition | null): string | false =>
  run !== null && `ai-changed ai-changed--${run}`;
